import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import ItemService from "../../services/supplier_appCommonService"

const ViewAllNotifications = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await ItemService.getNotifications({
        data: {
          page: 1,
          limit: 100,
        },
      });

      if (response?.status === 200) {
        setNotifications(response?.data || []);
      }
    } catch (err) {
      console.log("fetchNotifications err : ", err);
    }
  };

  const markAllAsRead = async () => {
    try {
      const response = await ItemService.markAllNotificationsRead({
        data: {},
      });

      if (response?.status === 200) {
        setNotifications((prev) =>
          prev.map((notif) => ({ ...notif, isRead: true }))
        );
      }
    } catch (err) {
      console.log("markAllAsRead err : ", err);
    }
  };

  const handleMarkSingleRead = async (notificationId) => {
    try {
      const response = await ItemService.markNotificationRead({
        data: {
          notificationId,
        },
      });

      if (response?.status === 200) {
        setNotifications((prev) =>
          prev.map((notif) =>
            notif.notificationId === notificationId
              ? { ...notif, isRead: true }
              : notif
          )
        );
      }
    } catch (err) {
      console.log("handleMarkSingleRead err : ", err);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center border-bottom">
          <h5 className="mb-0 fw-bold text-dark">Your Notifications</h5>
          <div className="d-flex gap-3">
            <button
              type="button"
              onClick={markAllAsRead}
              style={{
                background: "none",
                border: "none",
                color: "#0d6efd",
                fontSize: "18px",
                padding: 0,
                marginLeft: "10px",
              }}
            >
              Mark all as read
            </button>
          </div>
        </div>

        <div className="list-group list-group-flush">
          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <div
                key={notification.notificationId}
                className={`list-group-item list-group-item-action py-3 ${
                  notification.isRead ? "bg-white" : "bg-light"
                }`}
                onClick={() =>
                  handleMarkSingleRead(notification.notificationId)
                }
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex align-items-start">
                  <div
                    className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: "48px",
                      height: "48px",
                      background: "#f1f5ff",
                      fontSize: "20px",
                    }}
                  >
                    <i
                      className={`bi ${notification.icon || "bi-bell"} ${
                        notification.iconColor || "text-primary"
                      }`}
                    ></i>
                  </div>

                  <div className="flex-grow-1">
                    <p className="mb-2 text-dark fw-semibold">
                      {notification.title}
                    </p>
                    <p className="mb-2 text-muted">{notification.message}</p>
                    <div className="d-flex align-items-center text-muted small">
                      <span>
                        {notification.createdAt
                          ? new Date(notification.createdAt).toLocaleString()
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-muted py-4">
              No notifications found
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default ViewAllNotifications;